import {
  Shield,
  Calendar,
  Users,
  BarChart3,
  Settings,
  CreditCard,
  Heart,
  Ticket,
  UserCheck,
  QrCode,
  Fingerprint,
  Home,
  HelpCircle,
  Key,
  FileText,
  Building2,
  MapPin,
  Clock,
  DollarSign,
} from "lucide-react";

export const commonItems = [
  {
    title: "Dashboard",
    href: "/dashboard",
    icon: Home,
  },
  {
    title: "ID Verification",
    href: "/dashboard/verification",
    icon: Fingerprint,
  },
  {
    title: "QR Scanner",
    href: "/dashboard/scanner",
    icon: QrCode,
  },
];

export const bottomItems = [
  {
    title: "Settings",
    href: "/dashboard/settings",
    icon: Settings,
  },
  {
    title: "Support",
    href: "/dashboard/support",
    icon: HelpCircle,
  },
];

// Simplified navigation for digital ID product
export const digitalIdItems = [
  {
    title: "Dashboard",
    url: "/dashboard",
    icon: Home,
    isActive: true,
  },
  {
    title: "ID Verification",
    url: "/dashboard/verification",
    icon: Fingerprint,
  },
  {
    title: "QR Scanner",
    url: "/dashboard/scanner",
    icon: QrCode,
  },
];

// Role-specific navigation for mobile
export const roleNavigationItems = {
  'Patron': {
    icon: UserCheck,
    href: "/dashboard",
    subItems: [
      { title: "My Tickets", href: "/dashboard/tickets", icon: Ticket },
      { title: "Events", href: "/dashboard/events", icon: Calendar },
      { title: "Saved Events", href: "/dashboard/saved", icon: Heart },
      { title: "ID Verification", href: "/dashboard/verification", icon: Fingerprint },
      { title: "QR Scanner", href: "/dashboard/scanner", icon: QrCode },
    ],
  },
  'DJ': {
    icon: UserCheck,
    href: "/dashboard",
    subItems: [
      { title: "Gigs", href: "/dashboard/dj/gigs", icon: Calendar },
      { title: "Bookings", href: "/dashboard/dj/bookings", icon: CreditCard },
      { title: "ID Verification", href: "/dashboard/verification", icon: Fingerprint },
      { title: "QR Scanner", href: "/dashboard/scanner", icon: QrCode },
    ],
  },
  'Performer': {
    icon: UserCheck,
    href: "/dashboard",
    subItems: [
      { title: "Performances", href: "/dashboard/performer/gigs", icon: Calendar },
      { title: "Bookings", href: "/dashboard/performer/bookings", icon: CreditCard },
      { title: "ID Verification", href: "/dashboard/verification", icon: Fingerprint },
      { title: "QR Scanner", href: "/dashboard/scanner", icon: QrCode },
    ],
  },
  'Promoter': {
    icon: UserCheck,
    href: "/dashboard",
    subItems: [
      { title: "Events", href: "/dashboard/events", icon: Calendar },
      { title: "Guest Lists", href: "/dashboard/guest-lists", icon: Users },
      { title: "Analytics", href: "/dashboard/events/analytics", icon: BarChart3 },
      { title: "ID Verification", href: "/dashboard/verification", icon: Fingerprint },
      { title: "QR Scanner", href: "/dashboard/scanner", icon: QrCode },
    ],
  },
  'Venue Owner': {
    icon: UserCheck,
    href: "/dashboard",
    subItems: [
      { title: "Venue Profile", href: "/dashboard/venue/profile", icon: Building2 },
      { title: "Staff", href: "/dashboard/venue/staff", icon: Users },
      { title: "Events", href: "/dashboard/venue/calendar", icon: Calendar },
      { title: "Analytics", href: "/dashboard/venue/analytics", icon: BarChart3 },
      { title: "ID Verification", href: "/dashboard/verification", icon: Fingerprint },
      { title: "QR Scanner", href: "/dashboard/scanner", icon: QrCode },
    ],
  },
  'Employee': {
    icon: UserCheck,
    href: "/dashboard",
    subItems: [
      { title: "Schedule", href: "/dashboard/staff/schedule", icon: Clock },
      { title: "Reports", href: "/dashboard/staff/reports", icon: FileText },
      { title: "ID Verification", href: "/dashboard/verification", icon: Fingerprint },
      { title: "QR Scanner", href: "/dashboard/scanner", icon: QrCode },
    ],
  },
  'Security': {
    icon: UserCheck,
    href: "/dashboard",
    subItems: [
      { title: "Schedule", href: "/dashboard/security/schedule", icon: Clock },
      { title: "Access Control", href: "/dashboard/security/access", icon: Shield },
      { title: "Reports", href: "/dashboard/security/reports", icon: FileText },
      { title: "ID Verification", href: "/dashboard/verification", icon: Fingerprint },
      { title: "QR Scanner", href: "/dashboard/scanner", icon: QrCode },
    ],
  },
};
